
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Link } from 'react-router-dom';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

const classNames = mergeStyleSets({
    ArticleLink: {
        color: getTheme().semanticColors.link,
        textDecoration: 'none',
        ':hover': {
            color: getTheme().semanticColors.linkHovered,
            textDecoration: 'underline',
        }
    }
});

const ArticleLink = ({name, title}) => {
    return (
        <Link to={`/article/${name}`} className={classNames.ArticleLink}>{title}</Link>
    );
}

export default ArticleLink;
